import transitions from './transitions'

const theme = () => ({
  transitions
})

export default theme
